import React from "react";

import userIcon from './Ativo 1.svg'

export function VbabyIconUser({width, height, viewBox}) {

    return (
        <img width={width} height={height} src={userIcon} />
    )
}